import { ReactNode } from "react";
import { Card, CardContent, Typography, Skeleton } from "@mui/material";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import { Area, useAccess } from "../context/AccessContext";

// URL digitada direto nao pode renderizar a tela: sem isto a pagina abria e so
// quebrava depois, com cada chamada voltando 403.
export function RequireArea({ area, children }: { area: Area; children: ReactNode }) {
  const { can, loading } = useAccess();
  if (loading) return <Skeleton variant="rounded" height={120} />;
  if (!can(area)) return <SemAcesso />;
  return <>{children}</>;
}

export function SemAcesso() {
  return (
    <Card variant="outlined" data-testid="sem-acesso">
      <CardContent sx={{ display: "flex", gap: 2, alignItems: "center" }}>
        <LockRoundedIcon color="disabled" />
        <div>
          <Typography variant="h6">Sem acesso</Typography>
          <Typography variant="body2" color="text.secondary">
            Seu perfil neste tenant não tem acesso a esta área.
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
}
